
import CloudFun, { defineComponent, ref, Operator, onMounted, Condition } from '@cloudfun/core'
import * as XLSX from 'xlsx'
import Grid, { GridOptions } from '@/cloudfun/components/Grid.vue'

export default defineComponent({
  components: {
    Grid
  },
  setup() {
    const model = CloudFun.current?.model
    const grid = ref<any>({});
    const selectedBrand = ref("");
    const selectedPiece = ref("");
    const selectedWarehouse = ref("");
    const inputBarcode = ref("")
    const country = ref([]);
    const warehouses = ref([]);
    const isExportingExcel = ref(false);

    const gridOptions: GridOptions = {
      title: '現有庫存',
      mode: "inline",
      canCreate: false,
      canDelete: false,
      multiselect: false,
      toolbarConfig: {
        custom: true,
        refresh: true
      },
      printConfig: { sheetName: '現有庫存', modes: ['current', 'selected', 'all'] },
      exportConfig: { filename: '現有庫存', type: 'csv', types: ['html', 'csv'], mode: 'all', modes: ['current', 'selected', 'all'] },
      columns: [
        { field: 'Warehouse.Name', title: '倉庫', showHeaderOverflow: true, showOverflow: true, sortable: true },
        { field: 'Product.Brand.Name', title: '品牌', showHeaderOverflow: true, showOverflow: true, sortable: true },
        { field: 'Product.Barcode', title: '條碼', showHeaderOverflow: true, showOverflow: true, sortable: true },
        { field: 'Product.Number', title: '編號', showHeaderOverflow: true, showOverflow: true, sortable: true },
        { field: 'Product.Name', title: '產品', showHeaderOverflow: true, showOverflow: true, sortable: true },
        {
          field: 'SaftyQuantity', title: '安全庫存', showHeaderOverflow: true, showOverflow: true, align: "right",
          formatter: ({ cellValue }) => cellValue ? CloudFun.utils.formatMoney(cellValue) : "",
          editRender: {
            name: '$input',
            immediate: true,
            props: { type: 'number', min: 0 },
          }
        },
        { field: 'Quantity', title: '數量', showHeaderOverflow: true, showOverflow: true, align: "right", resizable: false, formatter: ({ cellValue }) => CloudFun.utils.formatMoney(cellValue), sortable: true },
      ],
      promises: {
        query: model ? async (params) => {
          if (selectedWarehouse.value !== "") {
            params.condition!.and("WarehouseId", Operator.Equal, selectedWarehouse.value);
          }
          if (selectedBrand.value !== "") {
            params.condition!.and("Product.BrandId", Operator.Equal, selectedBrand.value?.toString());
          }
          if (selectedPiece.value !== "") {
            params.condition!.and("Product.ProductAttributeValues.AttributeValue.DecimalValue", Operator.Equal, selectedPiece.value);
          }
          if (inputBarcode.value !== "" && /^[0-9]+$/.test(inputBarcode.value)) {
            params.condition!.and("Product.Barcode", Operator.Equal, inputBarcode.value)
          }
          return model.dispatch('inventory/query', params)
        } : undefined,
        queryAll: model ? () => {
          const condition = new Condition();
          if (selectedWarehouse.value !== "") condition.and("WarehouseId", Operator.Equal, selectedWarehouse.value);
          if (selectedBrand.value !== "") condition.and("Product.BrandId", Operator.Equal, selectedBrand.value?.toString());
          if (selectedPiece.value !== "") condition.and("Product.ProductAttributeValues.AttributeValue.DecimalValue", Operator.Equal, selectedPiece.value);
          if (inputBarcode.value !== "" && /^[0-9]+$/.test(inputBarcode.value)) condition.and("Product.Barcode", Operator.Equal, inputBarcode.value);
          return model.dispatch('inventory/query', { condition });
        } : undefined,
        save: model ? (params) => model.dispatch("inventory/save", params) : undefined,
      },
    }

    const getCountry = async () => {
      var sortings = [{ column: "Ordinal", order: 0 }];
      return model?.dispatch("brand/query", { sortings }).then((data) => {
        data = data.filter((item: any) => {
          return item.Name !== null
        }).sort((a: any, b: any) => {
          const nameA = a.Name.toUpperCase();
          const nameB = b.Name.toUpperCase();
          if (nameA < nameB) {
            return -1;
          } else if (nameA > nameB) {
            return 1
          } else {
            return 0
          }
        })
        return data;
      }).catch((error) => {
        console.log(error)
      })
    }

    onMounted(async () => {
      country.value = await getCountry();
      warehouses.value = await model?.dispatch('warehouse/query');
    })

    const exportToExcel = async () => {
      if (isExportingExcel.value) return; // 避免匯出中重複點擊觸發多次匯出
      isExportingExcel.value = true;
      try {
        const condition = new Condition();
        if (selectedWarehouse.value !== "") condition.and("WarehouseId", Operator.Equal, selectedWarehouse.value);
        if (selectedBrand.value !== "") condition.and("Product.BrandId", Operator.Equal, selectedBrand.value?.toString());
        if (selectedPiece.value !== "") condition.and("Product.ProductAttributeValues.AttributeValue.DecimalValue", Operator.Equal, selectedPiece.value);
        if (inputBarcode.value !== "" && /^[0-9]+$/.test(inputBarcode.value)) condition.and("Product.Barcode", Operator.Equal, inputBarcode.value);
        const data: any[] = await model?.dispatch('inventory/query', { condition }) || [];
        const headers = ['倉庫', '品牌', '條碼', '編號', '產品', '安全庫存', '數量'];
        const rows = data.map((item: any) => [
          item.Warehouse?.Name ?? '',
          item.Product?.Brand?.Name ?? '',
          item.Product?.Barcode ?? '',
          item.Product?.Number ?? '',
          item.Product?.Name ?? '',
          item.SaftyQuantity ?? '',
          item.Quantity ?? '',
        ]);
        const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, '現有庫存');
        XLSX.writeFile(wb, '現有庫存.xlsx');
      } finally {
        isExportingExcel.value = false;
      }
    };

    return {
      grid,
      gridOptions,
      selectedBrand,
      selectedPiece,
      selectedWarehouse,
      country,
      warehouses,
      inputBarcode,
      isExportingExcel,
      exportToExcel
    }
  },
  methods: {
    onGridRemoveSelectedRows(rows: any, callback: any) {
      cash('#batch-dropdown').dropdown('hide')
      callback()
    },
  }
})
